var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436.8,484.45c23.65-30.41,37.89-68.48,37.89-109.89c0-98.99-80.53-179.51-179.51-179.51 c-98.97,0-179.51,80.52-179.51,179.51c0,98.97,80.53,179.51,179.51,179.51c41.41,0,79.49-14.24,109.9-37.89l98.63,98.63 c4.38,4.38,10.12,6.57,15.86,6.57c5.74,0,11.48-2.19,15.87-6.57c8.76-8.76,8.76-22.96,0-31.73L436.8,484.45z M295.17,509.18 c-74.24,0-134.63-60.4-134.63-134.63s60.4-134.63,134.63-134.63s134.63,60.4,134.63,134.63S369.41,509.18,295.17,509.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch12);
export default __webpack_public_path__ + "static/media/search1 (2).384391733d02edd79423279f4ec8be8e.svg";
export { ForwardRef as ReactComponent };